import styled from 'styled-components';
import { COLORS, FONTS } from '@ertelecom/ui-react/assets/js/constants';
import GridContainer from '@ertelecom/ui-react/components/layouts/gridContainer';

export const Wrapper = styled.div`
    justify-content: flex-start;
    align-items: center;    
    padding: 90px 0;
    background: ${COLORS.white};
    color: ${COLORS.black};
    @media (max-width: 1599px) {
        padding: 70px 0;
    }
    @media (max-width: 1023px) {
        padding: 50px 0;
    }
    @media (max-width: 530px) {
        min-height: 0;
        padding: 16px 0 40px;
        overflow: hidden;
    }
`;

export const Container = styled(GridContainer)`
    justify-content: space-between;
    align-items: center;
    @media (max-width: 860px) {
        padding: 0 30px;
        margin-top: 14px;
    }
    @media (max-width: 460px) {
        padding: 0 16px;
    }
`;
export const TabContainer = styled.div`
    flex-wrap: nowrap;
    width: 100%;
    max-width: 1460px;
    align-items: flex-start;
    justify-content: space-between;
    @media (max-width: 1024px) {
        flex-direction: column-reverse;
    }
`;

export const Content = styled.div`
    flex-direction: column;
    justify-content: space-between;
    margin-right: 45px;
    margin-top: 30px;
    @media (max-width: 859px) {
        margin-right: 0px;
    }
   
`;

export const Title = styled.h3`
    font-family: ${FONTS.regular};
    font-size: 16px;
    line-height: 20px;
    margin-bottom: 15px;
    color: ${COLORS.black};
    @media (max-width: 859px) {
        font-size: 12px;
        line-height: 18px;
    }
`;

export const Text = styled.div`
    font-size: 32px;
    line-height: 40px;
    width: 100%;
    max-width: 896px;
    @media (max-width: 1440px) {
        max-width: 100%;
        margin-bottom: 15px;
        font-size: 28px;
        line-height: 36px;
    }
    @media (max-width: 859px) {
        font-size: 16px;
        line-height: 20px;
    }
`;

export const Image = styled.img`
    height: 220px;
    margin-top: 70px;
    @media (max-width: 1024px) {
        margin-top: 15px;
    }
    @media (max-width: 859px) {
        height: auto;
        width: 100%;
    }
`;
